var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AuthHeading',{attrs:{"title":"Log in to Eventor.app","sub-title":"Create events, import guest lists and check guests in from any device."}}),_c('AuthForm',{attrs:{"is-sign-in":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }